/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum ContentType {
  ContentfulCategoryEpisode = 'ContentfulCategoryEpisode',
  ContentfulCategoryEvent = 'ContentfulCategoryEvent',
  ContentfulCategoryEventVideo = 'ContentfulCategoryEventVideo',
  ContentfulCategoryShow = 'ContentfulCategoryShow',
  ContentfulCategoryVideo = 'ContentfulCategoryVideo',
  ContentfulEpisode = 'ContentfulEpisode',
  ContentfulEvent = 'ContentfulEvent',
  ContentfulEventVideo = 'ContentfulEventVideo',
  ContentfulExternalLink = 'ContentfulExternalLink',
  ContentfulMegaMenu = 'ContentfulMegaMenu',
  ContentfulShow = 'ContentfulShow',
  ContentfulSlug = 'ContentfulSlug',
  ContentfulVideo = 'ContentfulVideo',
  ContentfulWidgetCarousel = 'ContentfulWidgetCarousel',
  ContentfulWidgetContentBlock = 'ContentfulWidgetContentBlock',
  ContentfulWidgetMediaCollectionBuilder = 'ContentfulWidgetMediaCollectionBuilder',
  ContentfulWidgetSchedule = 'ContentfulWidgetSchedule',
  ContentfulWidgetSearch = 'ContentfulWidgetSearch',
  ContentfulWidgetBus = 'ContentfulWidgetBus',
}

export default ContentType;
